import { Skeleton } from '$shared/components/skeleton';
import styled from '@emotion/styled';

export const StyledSearchResultSkeleton = styled(Skeleton)(({ theme }) => ({
    margin: `${theme.space[1]} 0`,
    width: '100%',
}));